export const REFERRER_QUERY_PARAM = 'referrer';

export const QUEUES = 'queues';
export const GETTING_STARTED_PAGE_LEARN_BY_DOING = 'gettingStartedPageLearnByDoing';
